import { Stack, Text } from "flicket-ui";
import { useContext } from "react";
import { CompetitionContext } from "~features/competitions/CompetitionContext";
import { useTextColour } from "~hooks";

export const SocialShareFooter = ({ fixed }: { fixed?: boolean }) => {
  const { numberOfEntries } = useContext(CompetitionContext);
  const textColour = useTextColour("P300");

  return (
    <Stack
      alignItems={"center"}
      backgroundColor={"P300"}
      paddingY={{ _: 1, md: 3 }}
      paddingX={{ _: 1, md: 2 }}
      gap={2}
      width={"100%"}
      {...(fixed
        ? { zIndex: 1000, position: "fixed", bottom: "0%", left: 0 }
        : {})}
    >
      <Stack
        direction={{ _: "vertical", md: "horizontal" }}
        gap={"1/2"}
        justifyContent={{
          _: "space-between",
          md: fixed ? "space-between" : "center",
        }}
        alignItems="center"
        maxWidth="1184px"
        margin={"auto" as any}
        flex={1}
      >
        <Text variant="header.S" color={textColour}>
          You&apos;ve got {numberOfEntries}{" "}
          {numberOfEntries === 1 ? "entry" : "entries"}.
        </Text>
        <Text variant="header.S" fontWeight={"regular"} color={textColour}>
          Keep sharing to earn even more!
        </Text>
      </Stack>
    </Stack>
  );
};
